/* Kalis
 * To use this module add following line to theme.liquid, just before </body> tag
 * <script src="//lokk.no/cdn/shop/t/28/assets/kalis-forced-translations.js?v=120077207721972876951792870200" defer="defer"></script>
 */
// window.addEventListener('load', function() {
(function init() {
  // first replace shopify loaded texts
  replaceText();

  window.addEventListener('load', function() {
    // force replace text on following timeouts
    replaceText();

    setTimeout(replaceText, 50);
    setTimeout(replaceText, 100);
    setTimeout(replaceText, 150);
    setTimeout(replaceText, 200);
    setTimeout(replaceText, 250);
    setTimeout(replaceText, 300);
    setTimeout(replaceText, 350);
    setTimeout(replaceText, 400);
    setTimeout(replaceText, 450);
    setTimeout(replaceText, 500);
    setTimeout(replaceText, 600);
    setTimeout(replaceText, 700);
    setTimeout(replaceText, 800);
    setTimeout(replaceText, 900);
    setTimeout(replaceText, 1000);
    setTimeout(replaceText, 2000);
    setTimeout(replaceText, 3000);
    setTimeout(replaceText, 4000);
    setTimeout(replaceText, 5000);
    setTimeout(replaceText, 8000);
  });

  function replaceText() {
    // Style
    $('.product-single__meta').find('.variant-wrapper:nth-of-type(1)').children('label').text('Stil');

    // Colour
    $('.product-single__meta').find('.variant-wrapper:nth-of-type(2)').children('label').text('Farge');

    // Size
    $('.product-single__meta').find('.variant-wrapper:nth-of-type(3)').children('label').text('Størrelse');

    // More payment options
    $('.shopify-payment-button__more-options').text('Flere betalingsalternativer');

    // Buy with
    $('.shopify-payment-button__button').children('div').children('div').children('span:nth-of-type(2)').text('Betal med ');

    // Buy it now
    $('.shopify-payment-button__button--unbranded').text('Kjøp nå');
  }
})();
